module.exports = __webpack_public_path__ + "img/铜牌.a0f92fad.png";